import type { ReactElement } from 'react';

import { AUTOMATION_LEVELS, OTHER, TIME_SINKS } from '@/shared/config';

import { ChipGroup } from './chip-group';

/**
 * 2단계 — 지금 가장 반복적으로 시간 뺏기는 업무 **하나**.
 *
 * 복수 선택이 아니다. 다 고를 수 있으면 대부분 서너 개를 찍고, 그러면 「무엇부터 자동화할지」가
 * 다시 흐려진다. 하나로 강제해야 우선순위가 값으로 남는다.
 *
 * 「기타」에 짧은 서술을 붙인다 — 보기 다섯 개가 못 잡는 것을 받는 자리이고,
 * 이게 없으면 자기 업무가 없는 사람의 값이 통째로 「기타」로 뭉개진다.
 */
export function StepTimeSink({
  topTimeSink,
  topTimeSinkOther,
  onChange,
}: {
  topTimeSink: string;
  topTimeSinkOther: string;
  onChange: (patch: { topTimeSink?: string; topTimeSinkOther?: string }) => void;
}): ReactElement {
  return (
    <ChipGroup
      legend="하나 선택"
      name="onboarding-timesink"
      options={[...TIME_SINKS, OTHER]}
      selected={topTimeSink}
      onSelect={(topTimeSink) => onChange({ topTimeSink })}
      otherValue={topTimeSinkOther}
      onOtherChange={(topTimeSinkOther) => onChange({ topTimeSinkOther })}
      otherPlaceholder="매주 재고 대사, 계약서 검토 등"
    />
  );
}

/**
 * 3단계 — 자동화 경험 수준.
 *
 * 「기타」가 없다. 네 칸이 안 씀부터 전문 툴까지를 이미 덮으므로 빠져나갈 자리를 둘 이유가 없고,
 * 여기서 기타를 허용하면 난이도 축이 값 하나 때문에 못 쓰게 된다.
 */
export function StepAutomationLevel({
  automationLevel,
  onChange,
}: {
  automationLevel: string;
  onChange: (patch: { automationLevel?: string }) => void;
}): ReactElement {
  return (
    <ChipGroup
      legend="하나 선택"
      name="onboarding-level"
      options={AUTOMATION_LEVELS}
      selected={automationLevel}
      onSelect={(automationLevel) => onChange({ automationLevel })}
    />
  );
}

export function StepIndicator({
  current,
  total,
}: {
  current: number;
  total: number;
}): ReactElement {
  const steps = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <div className="flex items-center gap-1.5">
      {steps.map((step) => (
        <span
          key={step}
          aria-hidden="true"
          className={`h-1 w-6 rounded-full ${step <= current ? 'bg-foreground' : 'bg-border'}`}
        />
      ))}
      <span className="ml-1.5 font-mono text-[11px] text-muted-foreground">
        {total}단계 중 {current}단계
      </span>
    </div>
  );
}
